// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"FAQ_faqWrapper__1rDQn","container":"FAQ_container__2Bz2s","content":"FAQ_content__2EGwi","questions":"FAQ_questions__3Qk3F"};